import { BeFigure, FigureDataDto, preProcessFigureInput, TypeAheadItem, useArsContext } from "aic";
import { useAppSettings, useTlfContext } from "contexts/AppSettingsContext";
import { UPDATE_TLF } from "contexts/tlf/interface";
import { eTlfItemType } from "functions/api/enums";
import { getFigure } from "functions/api/figure/getFigure";
import { isTlfItemReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import React from "react";

/**
 * Wrapper for BeFigure that connects it to the TLF context
 */
export const InteractiveFigure: React.FC = () => {
  const appSettings = useAppSettings();
  const tlfContext = useTlfContext();
  const { state: arsState } = useArsContext();
  const body = isTlfItemReadDto(tlfContext.tlfData) ? tlfContext.tlfData.body : undefined;

  const varNames: TypeAheadItem[] =
    arsState.variables.length > 0
      ? arsState.variables.map((variable) => ({ value: variable.value }))
      : [{ value: "No variables available" }];

  const figureInput: FigureDataDto | undefined =
    tlfContext.tlfData?.type === eTlfItemType.figure
      ? preProcessFigureInput(appSettings.figureSettings, body as FigureDataDto)
      : undefined;

  return !figureInput || !tlfContext ? null : (
    <BeFigure
      backEndUrl={appSettings.backEndUrl}
      externalFigureRequest={getFigure}
      figureSettings={appSettings.figureSettings}
      figureInput={figureInput}
      varNames={varNames}
      updateFigureInput={(newBody: FigureDataDto) => {
        tlfContext.dispatch({
          operation: UPDATE_TLF,
          tlfData: {
            body: newBody,
          },
          calledFrom: "BeFigureOptions:updateFigureInput",
        });
      }}
    />
  );
};

InteractiveFigure.displayName = "InteractiveFigure";
